import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { createLocaleFormatters, type LocaleFormatters } from "~/helpers/localeFormat";
import { normalizeLanguage } from "~/i18n/languagePreference";

const useLocaleFormat = (): LocaleFormatters => {
	const { i18n } = useTranslation();
	const language = normalizeLanguage(i18n.resolvedLanguage ?? i18n.language);
	return useMemo(() => createLocaleFormatters(language), [language]);
};

export default useLocaleFormat;
